import React, { useEffect } from 'react';
import './CacheLoading.css';

const CacheLoading = ({ isLoading, text = "数据加载中，请稍等......" }) => {
  useEffect(() => {
    // 阻止或恢复页面交互
    if (isLoading) {
      document.body.classList.add('cache-loading-no-interaction');
    } else {
      document.body.classList.remove('cache-loading-no-interaction');
    }

    // 清理函数
    return () => {
      document.body.classList.remove('cache-loading-no-interaction');
    };
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div className="cache-loading-media-loading-overlay">
      <div className="cache-loading-loading-spinner"></div>
      <p className="cache-loading-loading-text">{text}</p>
    </div>
  );
};

export default CacheLoading;